export class StringComparer {

    public static compare(string1?: string, string2?: string): boolean {

        return (string1 ?? '').trim().toLowerCase() === (string2 ?? '').trim().toLowerCase()
    }

    public static isNullOrEmpty(value?: string): boolean {
        return !value || value.trim().length === 0;
    }
}
